<template>
  <div class="footer-div">
    <!--ログインしたユーザー表示するスロット -->
    <p class="c-name">河田興業 2019 All Right Reserved</p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.c-name {
  text-align: center;
  color: blue;
  margin: 0 auto;
}
.footer-div{
  background: rgb(43, 211, 65);
  padding: 20px;
  color: #fff;
  text-align: center;
  font-size: 30px;
  border-top:4px solid rgb(175, 152, 49);
  border-bottom: 4px solid rgb(175, 152, 49);
}
</style>